import { FC, ReactElement, useEffect, useState } from 'react';
import { routes } from '@/constants';
import { Navigate } from 'react-router-dom';
import { userManager } from '@/config/keycloak';
import { getUser } from '@/api/api';
import { jwtDecode } from 'jwt-decode';

interface ProtectedRouteProps {
  element: ReactElement;
  allowedRoles: string[];
}

interface DecodedToken {
  // biome-ignore lint/style/useNamingConvention: <explanation>
  realm_access?: {
    roles?: string[];
  };
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ element, allowedRoles }) => {
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const user = getUser();
        if (user && user.access_token) {
          const decodedToken = jwtDecode(user.access_token) as DecodedToken;
          const roles = decodedToken.realm_access?.roles || [];
          setUserRoles(roles);
        } else {
          await userManager.signinRedirect();
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const hasAllowedRole = userRoles.some((role) => allowedRoles.includes(role));

  if (hasAllowedRole) {
    return element;
  }

  return <Navigate to={routes.home} replace={true} />;
};

export default ProtectedRoute;
